export type MonitorConfig = {
  monitorStream: boolean;
  pollingInterval: number;
  projectId?: string;
  deploymentId?: string;
  logOutput: boolean;
};

export const DefaultMonitorConfig = {
  pollingInterval: 3, // in seconds
  logOutput: false,
};

export type VideoMonitorNotification = {
  projectId?: string;
  deploymentId?: string;
  kbps?: number;
  fps?: number;
};

export class VideoMonitor {
  config?: MonitorConfig;
  notify?: (notification: VideoMonitorNotification) => void;
  totalFrames: number = 0;
  kbps?: number;
  fps?: number;
  handle?: NodeJS.Timeout;
  video?: HTMLVideoElement;
  interrupted: boolean = false;

  init(config: MonitorConfig, notify: (msg: object) => void) {
    this.config = config;
    this.notify = notify;
  }

  stopMonitoring(): void {
    if (this.handle) {
      clearInterval(this.handle);
      this.handle = undefined;
      this.kbps = undefined;
      this.fps = undefined;
      this.totalFrames = 0;
    }
  }

  startMonitoring(): void {
    if (this.interrupted) {
      return;
    }
    this.stopMonitoring();
    if (this.config && this.config.monitorStream) {
      const fixedConfig: MonitorConfig = this.config;
      this.handle = setInterval(() => {
        if (this.interrupted) {
          return;
        }
        if (this.video) {
          let videoPlaybackQuality = this.video.getVideoPlaybackQuality();
          let newTotal = videoPlaybackQuality.totalVideoFrames;
          this.fps = (newTotal - this.totalFrames) / fixedConfig.pollingInterval;
          this.totalFrames = newTotal;
        }
        if (fixedConfig.logOutput) {
          if (this.kbps) {
            console.log(`Bitrate: ${this.kbps} kbps`);
          }
          if (this.fps) {
            console.log(`Frame rate: ${this.fps} fps`);
          }
        }
        if (this.notify && fixedConfig.deploymentId && this.kbps && this.fps) {
          this.notify({
            projectId: fixedConfig.projectId,
            deploymentId: fixedConfig.deploymentId,
            kbps: this.kbps,
            fps: this.fps,
          });
        }
      }, this.config.pollingInterval * 1000);
    }
  }
}
